import { TDrugSlot } from "app/_modules/core/types";

const SLOT_BOUNDARIES: Record<TDrugSlot, { start: number; end: number }> = {
    morning: { start: 5, end: 12 },
    afternoon: { start: 12, end: 18 },
    evening: { start: 18, end: 24 },
};

const SLOT_ORDER: TDrugSlot[] = ['morning', 'afternoon', 'evening'];

export const isSlotNow = (slot: TDrugSlot, now: Date): boolean => {
    const boundary = SLOT_BOUNDARIES[slot];
    if (!boundary) return false;
    const hour = now.getHours();
    return hour >= boundary.start && hour < boundary.end;
};

export const getElapsedSlots = (now: Date): TDrugSlot[] =>
    SLOT_ORDER.filter((slot) => now.getHours() >= SLOT_BOUNDARIES[slot].start);

export const getSlotRangeLabel = (slot: TDrugSlot): string => {
    const boundary = SLOT_BOUNDARIES[slot];
    if (!boundary) return '';
    const format = (hour: number) => `${String(hour % 24).padStart(2, '0')}:00`;
    return `${format(boundary.start)}–${format(boundary.end)}`;
};
